import apiClient from './apiClient';

export const getMediaUrl = (relativeUrl) =>
  apiClient.defaults.baseURL.replace(/\/api$/, '') + relativeUrl;

export const listDocuments   = (clientId)      => apiClient.get(`/clienti/${clientId}/documents/`).then(r => r.data);
export const deleteDocument  = (docId)         => apiClient.delete(`/documents/${docId}/`).then(r => r.data);

export const uploadDocument = (clientId, tip, tipCustom, file) => {
  const fd = new FormData();
  fd.append('tip', tip);
  if (tipCustom) fd.append('tip_custom', tipCustom);
  fd.append('file', file);
  return apiClient.post(`/clienti/${clientId}/documents/`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};
